<script lang="ts" setup>
</script>

<template>
  <article class="flex w-full flex-col items-center rounded-3xl bg-white p-[22px] md:p-10">
    <SvgIcon class="!size-6 md:!size-9" name="outlined/quote" />

    <h1 class="mb-6 mt-8 text-center text-lg font-medium text-main-green md:mb-[44px] md:mt-[60px] md:text-4xl">
      Мы&nbsp;с&nbsp;командой создали категорию консультаций на&nbsp;платформе&nbsp;iTAB, потому что уверены, что качественная профессиональная помощь должна быть доступна каждому. Наши эксперты проходят строгий отбор, и&nbsp;мы&nbsp;сотрудничаем только с&nbsp;лучшими специалистами, с&nbsp;которыми работаем уже не&nbsp;первый&nbsp;год. Этот сервис&nbsp;—&nbsp;это ваша уверенность в&nbsp;правильном выборе. Мы понимаем, как важно иметь доступ к&nbsp;проверенным профессионалам, готовым предложить точные решения для вашего здоровья и&nbsp;благополучия.
    </h1>

    <img
      class="size-[80px] rounded-full"
      loading="lazy"
      src="https://storage.yandexcloud.net/itab.pro/avatars/photo_2023-02-09_23-41-30.jpg"
    >

    <h2 class="mb-2 mt-4 text-sm font-medium md:text-base">
      Максим Ермолаев
    </h2>
    <strong class="block text-xs font-normal md:text-sm">Основатель iTAB</strong>
  </article>
</template>
